const tip = (t: any) => {
    return `<div style="color: #ececec; opacity: 0.9;">
    <div style="font-weight: bold;">
      ${t("addressEncoding.tip.geoQuality.title")}
    </div>
    <div style="display: flex; flex-direction: column">
      <div style="display: flex; margin-bottom: 10px">
        <div style="font-weight: bold; width: 100px; margin-right: 20px">
          ${t("addressEncoding.tip.geoQuality.Exact")}
        </div>
        <div style="flex: 1">${t("addressEncoding.tip.geoQuality.ExactExp")}</div>
      </div>
      <div style="display: flex; margin-bottom: 10px">
        <div style="font-weight: bold; width: 100px; margin-right: 20px">
          ${t("addressEncoding.tip.geoQuality.Place")}
        </div>
        <div style="flex: 1">${t("addressEncoding.tip.geoQuality.PlaceExp")}</div>
      </div>
      <div style="display: flex; margin-bottom: 10px">
        <div style="font-weight: bold; width: 100px; margin-right: 20px">
          ${t("addressEncoding.tip.geoQuality.ZIP")}
        </div>
        <div style="flex: 1">${t("addressEncoding.tip.geoQuality.ZIPExp")}</div>
      </div>
      <div style="display: flex">
        <div style="font-weight: bold; width: 100px; margin-right: 20px">
          ${t("addressEncoding.tip.geoQuality.ADMIN1")}
        </div>
        <div style="flex: 1">${t("addressEncoding.tip.geoQuality.ADMIN1Exp")}</div>
      </div>
    </div>
    </div>`
}

export default tip;